<mat-toolbar>
    <button
        mat-icon-button
        (click)="opened = !opened"
    >
        <mat-icon mat-list-icon>MENU</mat-icon>
    </button>

    <div class="headerHolder">
        <div class="imageHolder">
            <img
                src="{{ env }}/assets/exe.png"
                id="logo"
                class="logoHeader"
                alt="logo_exe"
            />
        </div>
        <div class="rightSide">
            <div class="logoCl">
                <img
                    src="{{ env }}/assets/{{ activeClient }}.png"
                    class="logoHeader"
                    alt="logo_exe"
                />
            </div>
            <div class="dropDowns">
                <div
                    class="clDrowpdown"
                    *ngIf="perms.superAdmin == 1"
                >
                    <button
                        mat-button
                        [matMenuTriggerFor]="menu"
                    >
                        Operator
                        <img
                            id="arrowDown"
                            src="https://img.icons8.com/metro/26/000000/expand-arrow.png"
                        />
                    </button>
                    <mat-menu #menu="matMenu">
                        <button
                            *ngFor="let client of clients"
                            mat-menu-item
                            (click)="clientChange(client)"
                        >
                            {{ client.name }}
                        </button>
                    </mat-menu>
                </div>
                <div class="userDropDown">
                    <button
                        *ngIf="loadedPerms == true"
                        mat-button
                        [matMenuTriggerFor]="menu2"
                    >
                        {{ perms.username }}
                        <img
                            id="arrowDown"
                            src="https://img.icons8.com/metro/26/000000/expand-arrow.png"
                        />
                    </button>
                    <mat-menu #menu2="matMenu">
                        <a
                            mat-menu-item
                            routerLink="/home/password_reset/"
                            routerLinkActive="active-link"
                            >Password</a
                        >
                        <button mat-menu-item>Management</button>
                        <button
                            mat-menu-item
                            (click)="logOut()"
                        >
                            Logout
                        </button>
                    </mat-menu>
                </div>
            </div>
        </div>
    </div>
</mat-toolbar>
